<template>
    <div class="envelope-title-heading">
        <mail-icon size="20" class="flex-none text-gray-500" aria-hidden="true" />
        <div class="envelope-title-controls">
        <h1 class="text-lg font-semibold break-words min-w-0">
            <button v-if="editable" type="button" class="envelope-name" @click="editTitle">{{ value || 'Untitled envelope' }}</button>
            <span v-else>{{ value || 'Untitled envelope' }}</span>
        </h1>
        <button v-if="editable" type="button" class="envelope-rename text-blue-600 flex-none" @click="editTitle">Rename</button>
        </div>
        <modal :name="modalName" :adaptive="true" :focusTrap="true" :width="480" height="auto" @opened="focusTitle" @closed="editing = false">
            <form class="envelope-edit-modal p-6 bg-white" @submit.prevent="saveTitle">
                <h2 class="text-lg font-semibold pb-4 mb-4">Rename envelope</h2>
                <label for="rename-envelope-title" class="block text-sm font-medium text-gray-700 mb-2">envelope name</label>
                <input id="rename-envelope-title" ref="titleInput" v-model="draft" required maxlength="255" class="envelope-title-input" />
                <div class="flex justify-end gap-3 mt-6">
                    <button type="button" class="envelope-button" @click="cancelTitle">Cancel</button>
                    <button type="submit" class="envelope-button envelope-primary" :disabled="!draft.trim()">Save</button>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>
import { MailIcon } from 'vue-feather-icons';

export default {
    components: { MailIcon },
    props: { read_only: { default: false },
        value: {},
        creating: { default: false },
        toast: {},
        envelope: {},
    },
    data() { return { editing: false, draft: this.value || '' }; },
    computed: {
        modalName() { return `envelope-rename-${this._uid}`; },
        editable() { return !this.read_only && !this.envelope?.sent_at; },
    },
    methods: {
        editTitle() {
            if (!this.editable) return;
            this.draft = this.value || '';
            this.editing = true;
            this.$modal.show(this.modalName);
        },
        focusTitle() { this.$refs.titleInput?.focus(); },
        cancelTitle() { this.editing = false; this.$modal.hide(this.modalName); },
        saveTitle() {
            if (!this.editable || !this.draft.trim()) return;
            this.$emit('input', this.draft.trim());
            this.editing = false;
            this.$modal.hide(this.modalName);
        },
    },
};
</script>

<style scoped>
.envelope-title-heading { display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1.5rem; }
.envelope-title-heading h1 { margin: 0; }
.envelope-name { text-align: left; }
.envelope-name:hover { color: #2563eb; }
.envelope-title-controls { display: flex; align-items: baseline; gap: 1.25rem; min-width: 0; }
.envelope-rename { font-size: 0.75rem; opacity: 0; pointer-events: none; text-decoration: none; }
.envelope-title-controls:hover .envelope-rename,
.envelope-title-controls:focus-within .envelope-rename { opacity: 1; pointer-events: auto; }
.envelope-title-input { width: 100%; max-width: 100%; padding: 0.375rem 0.625rem; font-size: 0.875rem; border: 1px solid #d1d5db; border-radius: 0.375rem; }
</style>
